/* Dynamic Plot code copyright 2024 (c) Tuva Labs Inc. */
/**
 * created by cmiller
 */

/** class for drop areas in the plot view */
export class DropArea {
    constructor( Dyn, axisID ) {
        this.Dyn = Dyn;
        this.axisID = axisID;
        this.dropRect = null; // visible drop area
        this.dropRectOverlay = null; // invisible overlay for drag events, to prevent mouse events from going through
        this.bounds = new Dyn.mathUtil.Rect( 0, 0, 0, 0 );
        this.stdHeight = 0;
    }
    initVisuals( paper, bounds, viewAreaID, marginView ) {
        let Dyn = this.Dyn;
        Dyn.assert( marginView );
        this.bounds.copyRect( bounds );

        this.dropRect = paper.rect( bounds.x, bounds.y, bounds.width, bounds.height, 0 )
        this.dropRect.node.setAttribute("id", viewAreaID);
        this.dropRect.node.setAttribute("class", Dyn.plotUtil.hideOnPreviewClass);

        this.dropRectOverlay = paper.rect( this.bounds.x, this.bounds.y, this.bounds.width, this.bounds.height, 0 )
            .attr({ fill:"white" , stroke: "none", opacity: Dyn.plotUtil.opacityInvisibleButDraggable })
            .data( "axisID", this.axisID )
            .hide();
        if(!Dyn.environment.isTouchDevice()) {
            // attribute drag and drop event handlers
            this.dropRectOverlay.mouseover( () =>
                marginView.mouseOverDroppableAreas( this ));
            this.dropRectOverlay.mouseout( () =>
                marginView.mouseOutDroppableAreas( this ));
            this.dropRectOverlay.mouseup( () =>
                marginView.mouseUpHandler( this ));
        }
    }

    updateVisuals( bounds, fillColor, strokeColor, strokeOpacity, fillOpacity ) {
        let Dyn = this.Dyn;
        this.bounds.copyRect( bounds );
        this.dropRect.attr({
            x: bounds.x,
            y: bounds.y,
            width: bounds.width,
            height: bounds.height,
            fill: fillColor,
            stroke: strokeColor,
            'stroke-width': Dyn.plotUtil.promptDropRectStrokeWidth,
            'stroke-opacity': strokeOpacity,
            opacity: fillOpacity
        });
        this.dropRectOverlay.attr({
            x: bounds.x,
            y: bounds.y,
            width: bounds.width,
            height: bounds.height
        });
    }

    // setCanDropFunc( canDropFunc ) {
    //     this.canDropFunc = canDropFunc;
    // }
    //
    // calcHeight() {
    //     return this.canDropFunc () ? this.stdHeight : 0;
    // }

    // canDrop() {
    //     return this.bounds.height > 0;
    // }

    getDropRectFillColor( isIncompleteAxis=false, usePromptColor=false, dropState=null ) {
        let Dyn = this.Dyn;
        Dyn.DropState.isValid( dropState );
        if( isIncompleteAxis ) {
            return Dyn.plotUtil.warningDropFillColor;
        } else if( dropState==="isHighlight" ){
            return Dyn.plotUtil.highlightDropFillColor;
        } else if( usePromptColor ){
            return Dyn.plotUtil.promptDropFillColor;
        } else {
            return Dyn.plotUtil.normalDropColor;
        }
    }

    getDropRectFillOpacity( hasValidAttribute, isPrompting, isDraggingAttribute ) {
        // Dyn.DropState.isValid( dropState );
        let Dyn = this.Dyn,
            opacity;
        if( isDraggingAttribute || isPrompting ) {
            opacity = 1; // obscure background when dragging attributes or showing prompt
        } else if( hasValidAttribute ) {
            opacity = Dyn.plotUtil.kLegendOpacity; // show map behind legend
        } else {
            opacity = 0; // invisible if no legend or prompt, especially for map plot
        }
        return opacity;
    }

    highlightDropAreas( dropRect, fillColor, isUsingPromptTitle ) {
        let Dyn = this.Dyn;
        this.dropRect.attr( {
            x: dropRect.x,
            y: dropRect.y,
            width: dropRect.width - 1, // -1 to show full 2 pixel border
            height: dropRect.height,
            fill: fillColor,
            stroke: Dyn.plotUtil.highlightDropStrokeColor,
            'stroke-width': Dyn.plotUtil.highlightDropRectStrokeWidth,
            'stroke-opacity': 1,
            opacity: 1 //this.getDropRectStrokeOpacity()
        } );

        // position and show the drop rect overlay
        this.dropRectOverlay.attr(dropRect).show();
    }
}

